export const isMobile = () => {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

export const isHarmonyOS = () => {
  const userAgent = navigator.userAgent;
  return /OpenHarmony/i.test(userAgent);
}

export const isHuaweiOrHonor = () => {
  const ua = navigator.userAgent.toLowerCase();
  // 检测华为或荣耀的关键字
  return /huawei|honor|h60|hi6210|ath-ul06|hol-u19|hw-|h30|che2|chm|hi3660|knt|al10|clt|eva/i.test(ua);
}

export const isAndroid = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('android') > -1 || ua.indexOf('linux') > -1;
}

export const isIOS = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua);
}